import { Checkbox } from '@livechat/design-system-react-components'
import { css } from '@emotion/react'

import type { IAgentItem } from '@/store/agents/interfaces'

interface IAgentRowProps {
  agent: IAgentItem
  updateRecipients: (email: string) => void
  checked: boolean
}

const fixLabelDescriptionGapCss = css`
  display: flex;
  flex-direction: column;
`

const AgentRow = ({ agent, updateRecipients, checked }: IAgentRowProps) => {
  const { email, name } = agent
  const onChange = () => updateRecipients(email)

  return (
    <Checkbox
      id={`checkbox-agent-${email}`}
      checked={checked}
      onChange={onChange}
      description={email}
      css={fixLabelDescriptionGapCss}
    >
      {name}
    </Checkbox>
  )
}

export default AgentRow
